// Header.jsx
import React, { useState, useLayoutEffect } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import logoZ from "../assets/images/logos/logoZ.png";
import logoZASFIT from "../assets/images/logos/logoZASFIT.png";

import "./Header.css";

const APP_URL = process.env.REACT_APP_APP_URL || "https://app.zasfit.io";
const NAV_ITEMS = [
  { id: "home",     label: "Inicio",    icon: "home" },
  { id: "services", label: "Aplicación", icon: "view_quilt" },
  { id: "pricing",  label: "Precios",   icon: "sell" },
  { id: "contact",  label: "Contacto",  icon: "help" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  // const openTidio = useCallback((e) => {
  //   e.preventDefault();
  //   e.currentTarget.blur();
  //   const run = () => window.tidioChatApi?.open();
  //   if (window.tidioChatApi) run();
  //   else document.addEventListener("tidioChat-ready", run, { once: true });
  // }, []);

  const getScrollTop = () =>
    window.pageYOffset ?? document.documentElement.scrollTop ?? 0;

  useLayoutEffect(() => {
    const onScroll = () => setScrolled(getScrollTop() > 25);
    onScroll(); // 👈 establece el estado inicial al cargar
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  /* render auxiliar */
  const renderNavLink = ({ id, label, icon }, isMobile = false) => {
    // construimos SIEMPRE rutas absolutas hacia la home
    const href =
      id === "home"
        ? "/"                     // home sin ancla
        : id === "contact"
        ? "/#chat"                // por si falla el widget, al menos hay ancla de fallback
        : `/#${id}`;              // /#services, /#pricing, etc.

    const common = {
      href,
      onClick: id === "contact"
        ? (e) => {
            e.preventDefault();
            const run = () => window.top?.tidioChatApi?.open?.();
            if (window.tidioChatApi) run();
            else document.addEventListener("tidioChat-ready", run, { once: true });
            // si quieres además forzar ir a /#chat cuando el widget no responde en X ms:
            // setTimeout(() => { if (!window.tidioChatApi) window.location.href = "/#chat"; }, 800);
          }
        : undefined,
      className: `d-flex align-items-center ${isMobile ? "justify-content-center" : ""} gap-1`,
    };

    return (
      <a {...common}>
        <span className="material-symbols-outlined">{icon}</span>
        <span className="nav-text">{label}</span>
      </a>
    );
  };

  return (
    <header className={`main-header header ${scrolled ? "scrolled" : "transparent"}`}>
      <div className="container">
        <div className="header-bar d-flex align-items-center justify-content-between py-20">
          {/* ---------- LOGO + NAV DESKTOP ---------- */}
          <div className="left-block d-flex align-items-center">
            <a
              href="/"
              className="logo d-flex align-items-center wow animate__animated animate__fadeIn"
              aria-label="ZASFIT | Inicio"
              data-wow-delay="0.03s"
            >
              {/* reserva tamaño → sin reflujo */}
              <img
                src={logoZ}
                alt=""
                className="site-logo"
                width="62"
                height="62"
                loading="eager"
              />
              <img
                src={logoZASFIT}
                alt="ZASFIT"
                className="site-wordmark"
                width="171"
                height="40"
                loading="eager"
              />
            </a>

            {/* NAV DESKTOP */}
            <nav className="nav-wrapper d-none d-xl-flex ms-5">
              <ul className="nav-list">
                {NAV_ITEMS.map((item, i) => (
                  <li
                    key={item.id}
                    className="wow animate__animated animate__fadeIn"
                    data-wow-delay={`${0.03 + i * 0.01}s`}
                  >
                    {renderNavLink(item)}
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          {/* ---------- CTAs DESKTOP ---------- */}
          <div className="d-none d-xl-inline-flex align-items-center">
            <a
              href={`${APP_URL}/auth/login`}
              className="theme-btn style-five d-inline-flex align-items-center wow animate__animated animate__fadeIn"
              data-wow-delay="0.05s"
            >
              <span className="material-symbols-outlined">space_dashboard</span>
              <span>Accede</span>
            </a>
            <a
              href={`${APP_URL}/auth/register`}
              className="theme-btn style-five btn-start ms-3 d-inline-flex wow animate__animated animate__fadeIn"
              data-wow-delay="0.03s"
            >
              Empieza&nbsp;Gratis
            </a>
          </div>

          {/* ---------- BURGER ---------- */}
          <button
            className="navbar-toggle d-xl-none ms-auto wow animate__animated animate__fadeIn"
            data-wow-delay="0.40s"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mobile-menu"
          >
            <span className="icon-bar" /><span className="icon-bar" /><span className="icon-bar" />
          </button>
        </div>

        {/* ---------- NAV MÓVIL ---------- */}
        <div id="mobile-menu" className="collapse d-xl-none">
          <ul className="nav-mobile list-unstyled mb-0 py-3">
            {/* enlaces normales */}
            {NAV_ITEMS.map((item, i) => (
              <li
                key={item.id}
                className="py-2 text-center wow animate__animated animate__fadeIn"
                data-wow-delay={`${0.10 + i * 0.05}s`}      // 0.10 – 0.25 s
              >
                {renderNavLink(item, true)}
              </li>
            ))}

            {/* --- CTA · Accede -------------------------------- */}
            <li
              className="py-0 text-center wow animate__animated animate__fadeIn"
              data-wow-delay="0.30s"                          // ⬅️ empieza después de los links
            >
              <a
                href={APP_URL}
                className="theme-btn style-five cta-btn cta-login d-flex align-items-center justify-content-center gap-1"
              >
                <span className="material-symbols-outlined">space_dashboard</span>
                <span>Accede</span>
              </a>
            </li>

            {/* --- CTA · Empieza gratis ----------------------- */}
            <li
              className="pb-2 mb-10 text-center wow animate__animated animate__fadeIn"
              data-wow-delay="0.35s"                          // ⬅️ un pelín más tarde
            >
              <a
                href={APP_URL}
                className="theme-btn style-five cta-btn cta-start"
              >
                Empieza&nbsp;Gratis
              </a>
            </li>
          </ul>
        </div>


      </div>
    </header>
  );
}
